import { createFileRoute, redirect } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/chat/$chatId')({
  beforeLoad: ({ params }) => {
    requirePermission('chat:respond');
    // The conversation now lives in the search-param-driven workspace at
    // /app/chat. Preserve deep links (the new-chat toast's Open action, old
    // bookmarks) by redirecting into the Active tab with this chat preselected.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/app/chat', search: { tab: 'active', chatId: params.chatId } });
  },
  staticData: { crumb: 'Chat' },
});
